import React from 'react';
import HomepageAsset from 'public/screens/Home/Components/Asset';

import useCustomStyle from '../../hooks';
import { parseVideoSettings } from '../../utils';

export default function CLPAsset({
  asset,
  settings,
  videoProps,
  videoEvents,
  videoStyle,
  ...props
}) {
  const combinedSettings = [
    ...(asset?.fields?.settings || []),
    ...(settings || []),
  ];
  const [, styles] = useCustomStyle(combinedSettings);
  const parsedVideoProps = parseVideoSettings(styles);
  const mergedVideoProps = {
    ...parsedVideoProps,
    ...(videoProps || {}),
  };
  const autoplay =
    styles['--video-no-autoplay'] === 'true'
      ? false
      : mergedVideoProps.autoplay;
  const videoEventsFromSettings = {
    ...(styles['--video-play-on-hover'] === 'true' && { playOnHover: true }),
    ...(styles['--video-stop-on-leave'] === 'true' && { stopOnLeave: true }),
    ...(styles['--video-pause-on-leave'] === 'true' && { pauseOnLeave: true }),
    ...(autoplay === false && {
      autoplay: false,
    }),
    ...(autoplay === true && { autoplay: true }),
  };
  const videoStyleFromSettings = styles['--video-opacity']
    ? { opacity: styles['--video-opacity'] }
    : {};

  return (
    <HomepageAsset
      asset={asset}
      videoProps={mergedVideoProps}
      videoEvents={{
        ...(videoEvents || {}),
        ...videoEventsFromSettings,
      }}
      videoStyle={{
        ...videoStyleFromSettings,
        ...(videoStyle || {}),
      }}
      {...props}
    />
  );
}
